import { useState, useEffect } from "react";
import axios from "axios";
import { api, api_V2 } from "../Environments/Environment.Test";
import { API_ENDPOINTS } from "../api/index";
import { data } from "autoprefixer";
import useOrder from "./useOrder";
import store from "../store";

const BASE_URL = `${api}/`; // Define your default base URL here
const BASE_URL_V2 = `${api_V2}/`;

export const useCloud = () => {
  // const { cleanSyncedOrders , flushAllCompleteOrders, getLatestBillNumber} = useOrder();
  const [token, setToken] = useState(null);

  useEffect(() => {
    const fetchToken = async () => {
      const storedToken = await localStorage.getItem("authToken");
      setToken(storedToken);
    };
    fetchToken();
  }, []);

  const apiInstance = axios.create({
    baseURL: BASE_URL,
  });

  const apiInstance_V2 = axios.create({
    baseURL: BASE_URL_V2,
  });

  // Set up Axios interceptors
  useEffect(() => {
    apiInstance.interceptors.request.use(
      async (config) => {
        const token = await localStorage.getItem("authToken");
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        config.headers["Content-Type"] = "application/json";
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }, [token, apiInstance]);

  useEffect(() => {
    apiInstance_V2.interceptors.request.use(
      async (config) => {
        const token = await localStorage.getItem("authToken");
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        config.headers["Content-Type"] = "application/json";
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }, [token, apiInstance_V2]);

  const addCategoryAPI = async (requestBody) => {
    try {
      const res = await apiInstance.post(
        API_ENDPOINTS.ADD_CATEGORY,
        requestBody
      );
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const allCategories = async () => {
    try {
      const res = await apiInstance.get(API_ENDPOINTS.ALL_CATEGORIES);
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const deleteItem = async (id) => {
    try {
      const res = await apiInstance.delete(API_ENDPOINTS.DELETE_ITEM(id));
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const addItemAPI = async (requestBody) => {
    try {
      const res = await apiInstance.post(API_ENDPOINTS.ADD_ITEM, requestBody);
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const updateItem = async (requestBody, id) => {
    try {
      const res = await apiInstance.put(
        API_ENDPOINTS.UPDATE_ITEM(id),
        requestBody
      );
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const getAllItems = async () => {
    try {
      const res = await apiInstance.get(API_ENDPOINTS.GET_ALL_ITEMS);
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };


  const tableData = async () => {
    try {
      const res = await apiInstance.get(API_ENDPOINTS.TABLE_DATA);
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const getTableData = async () => {
    try {
      const res = await apiInstance.get(API_ENDPOINTS.GET_TABLE_DATA);
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const requestedKOTData = async () => {
    try {
      const res = await apiInstance.get(API_ENDPOINTS.REQUESTED_KOT_DATA);
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const changeKOTStatus = async (requestBody) => {
    try {
      const res = await apiInstance.post(
        API_ENDPOINTS.CHANGE_KOT_STATUS,
        requestBody
      );
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const orderDone = async (requestBody) => {
    try {
      const res = await apiInstance.post(API_ENDPOINTS.ORDER_DONE, requestBody);
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const createOrderByRestarunt = async (requestBody) => {
    try {
      const res = await apiInstance.post(
        API_ENDPOINTS.CREATE_ORDER_BY_RESTAURANT,
        requestBody
      );
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const extraAmountAdded = async (requestBody) => {
    try {
      const res = await apiInstance.post(
        API_ENDPOINTS.EXTRA_AMOUNT_ADDED,
        requestBody
      );
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const editExistingOrder = async (requestBody) => {
    try {
      const res = await apiInstance.post(
        API_ENDPOINTS.EDIT_EXISTING_ORDER,
        requestBody
      );
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const paymentMethodAPI = async (requestBody) => {
    try {
      const res = await apiInstance.post(
        API_ENDPOINTS.PAYMENT_METHOD,
        requestBody
      );
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const changePaymentMethod = async (requestBody) => {
    try {
      const res = await apiInstance.post(
        API_ENDPOINTS.CHANGE_PAYMENT_METHOD,
        requestBody
      );
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const orderReject = async (requestBody) => {
    try {
      const res = await apiInstance.post(
        API_ENDPOINTS.ORDER_REJECT,
        requestBody
      );
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const changeQuentityOfItem = async (requestBody) => {
    try {
      const res = await apiInstance.post(
        API_ENDPOINTS.CHANGE_QUANTITY_OF_ITEM,
        requestBody
      );
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const getPublicItemBYVPA = async (vpa) => {
    try {
      const res = await apiInstance.get(
        API_ENDPOINTS.GET_PUBLIC_ITEM_BY_VPA(vpa)
      );
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const getWaiterList = async () => {
    try {
      const res = await apiInstance.get(API_ENDPOINTS.GET_WAITER_LIST);
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const getAllCategoryAndItem = async () => {
    try {
      const res = await apiInstance.get(
        API_ENDPOINTS.GET_ALL_CATEGORY_AND_ITEM
      );
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };


  const syncCloud = async (orders) => {
    return;
    // if (store.syncLock) {
    //   console.log("Sync in process, scheduled after 10sec")
    //   setTimeout(() => {
    //     syncCloud()
    //   }, 10000)
    //   return
    // }

    // store.syncLock = true

    // if (!navigator.onLine) {
    //   console.log("No internet connection");
    //   return;
    // }
    // try {

    //   const transformOrders = await cleanSyncedOrders();
    //   const convertTimeToSQLTime = (_date) => {
    //     const date = new Date(_date);
    //     const year = date.getFullYear();
    //     const month = String(date.getMonth() + 1).padStart(2, "0");
    //     const day = String(date.getDate()).padStart(2, "0");
    //     const hours = String(date.getHours()).padStart(2, "0");
    //     const minutes = String(date.getMinutes()).padStart(2, "0");
    //     const seconds = String(date.getSeconds()).padStart(2, "0");

    //     return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    //   };

    //   const processedOrders = transformOrders.map((order) => {
    //     store.setLastBillNo(order.billNo);
    //     return {
    //       orderID: order.orderID,
    //       billNo: order.billNo,
    //       name: order.username,
    //       mobile: order.usermobile,
    //       tableVPA: order.tableVPA,
    //       amount: order.amount,
    //       isCancle: order.status === "BILLCancelled",
    //       cancelReason : order.cancelReason || '',
    //       items: order.printKOT.items.filter(item => !item.extra).map((item) => ({
    //         id: item.feUniqueItemId,
    //         quantity: parseInt(item.quantity),
    //         name: `${item.name} ${item.isVariant ? `- ${item.variant}` : ""}`,
    //         price: item.price,
    //       })),
    //       paymentmethod: order?.payment?.methods || [
    //         { name: "Cash", amount: order.amount },
    //       ],
    //       waiterid: order.assignedWaiter,
    //       discount: order?.billTxnLogs?.discount || 0,
    //       extraitem: order.extraOrders.map((item) => ({
    //         quantity: parseInt(item.quantity),
    //         name: item.name,
    //         price: item.price,
    //       })),
    //       createdAt: convertTimeToSQLTime(order.createdAt),
    //       updatedAt: convertTimeToSQLTime(order.updatedAt),
    //       tips: order?.billTxnLogs?.tip || 0,
    //       onlineCodes: order.onlineCodes,
    //       billingTransactionLog: order.billTxnLogs || {}
    //     };
    //   });

    //   const payload = {
    //     data: processedOrders,
    //   };

    //   return new Promise(async (resolve, reject) => {
    //     try {
    //       const { data } = await apiInstance.post(
    //         API_ENDPOINTS.SYNC_CLOUD,
    //         payload
    //       );
    //       if (data.event) {
    //         const processedBills = processedOrders.map(order => order.orderID)
    //         localStorage.setItem('processedBills', JSON.stringify( processedBills))
    //         // flushAllCompleteOrders()
    //         resolve(true);
    //       } else {
    //         reject(false);
    //       }
    //     } catch (err) {
    //       reject(err);
    //     } finally {
    //       store.syncLock = false
    //     }
    //   });

    // }
    // catch (e) {
    //   console.log("Error in sync cloud")
    //   console.log(e)
    // } finally {
    //   store.syncLock = false
    // }
  };

  const getOrderHistory = async (currentPage) => {
    try {
      const res = await apiInstance.get(API_ENDPOINTS.ORDER_DETAILS, {
        params: { page: currentPage },
      });
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const getDigitalOrders = async () => {
    try {
      const res = await apiInstance.get(API_ENDPOINTS.GET_DIGITAL_ORDER);
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };
  const gstUpdate = async (orders) => {
    const payload = {
      ...orders,
    };
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await apiInstance.post(
          API_ENDPOINTS.UPDATE_GST,
          payload
        );
        if (data.event) {
          resolve(true);
        } else {
          reject(false);
        }
      } catch (err) {
        reject(err);
      }
    });

    return true;
  };

  const categoryUpdate = async (orders) => {
    const payload = {
      ...orders,
    };
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await apiInstance.put(
          API_ENDPOINTS.CATEGORY_UPDATE,
          payload
        );
        if (data) {
          resolve(data);
        } else {
          reject(false);
        }
      } catch (err) {
        reject(err);
      }
    });
  };

  const categoryDelete = async (id) => {
    try {
      const res = await apiInstance.delete(API_ENDPOINTS.CATEGORY_DELETE(id));
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const itemWiseSale = async () => {
    try {
      const { data } = await apiInstance.get(API_ENDPOINTS.GET_ITEM_WISE_SALE);
      return data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const registerNotificationToken = async (token) => {
    try {
      const res = await apiInstance.post(
        API_ENDPOINTS.REGISTER_NOTIFICATION_TOKEN,
        { token }
      );
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const testNotification = async () => {
    try {
      const res = await apiInstance.get(API_ENDPOINTS.TEST_NOTIFICATION);
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const updateWaiter = async (requestBody) => {
    try {
      const res = await apiInstance.put(
        API_ENDPOINTS.CHANGE_STATUS_WAITER,
        requestBody
      );
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };
  const removeWaiter = async (requestBody) => {
    try {
      const res = await apiInstance.put(
        API_ENDPOINTS.REMOVE_WAITER,
        requestBody
      );
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };
  const addNewWaiter = async (requestBody) => {
    try {
      const res = await apiInstance.post(
        API_ENDPOINTS.ADD_NEW_WAITER,
        requestBody
      );
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const partnerAPIIngegration = async (requestBody) => {
    try {
      const res = await apiInstance.post(
        API_ENDPOINTS.PARTNER_API_INTEGRATION,
        requestBody
      );
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const getCurrentDayOrders = async () => {
    try {
      const res = await apiInstance.get(API_ENDPOINTS.GET_REPORT_FOR_CANCLE);
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const cancelOrder = async (requestBody) => {
    try {
      const res = await apiInstance.post(
        API_ENDPOINTS.CANCEL_ORDER,
        requestBody
      );
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const getBillByBillNo = async (requestBody) => {
    try {
      const res = await apiInstance.post(
        API_ENDPOINTS.EXTRA_ITEM_GET_BY_BILL,
        requestBody
      );
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const addPriceRule = async (requestBody) => {
    try {
      const res = await apiInstance.post(API_ENDPOINTS.DYNAMIC_PIRCE, requestBody);
      return res.data;
    } catch (err) {
      throw err;
    }
  }

  const deletePriceRule = async (requestBody) => {
    try {
      const res = await apiInstance.delete(API_ENDPOINTS.DYNAMIC_PIRCE, {data: requestBody});
      return res.data;
    } catch (err) {
      throw err;
    }
  }



  // V2

  const login = async (payload) => {
    try {
      const res = await apiInstance_V2.post(API_ENDPOINTS.LOGIN_V2, payload);
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const updateGST = async (payload) => {
    try {
      const res = await apiInstance_V2.patch(API_ENDPOINTS.GST, payload);
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  }

  const dashboard = async ({
    startDate = '', endDate = '', dateType = 'all'
  }) => {
    try {
      const res = await apiInstance_V2.get(`${API_ENDPOINTS.DASHBOARD_V2}?startDate=${startDate}&endDate=${endDate}&dateType=${dateType}`);
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const getRestaurantInfo = async () => {
    try {
      const res = await apiInstance_V2.get(API_ENDPOINTS.RESTAURANT_DETAILS);
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const getMenu = async () => {
    try {
      const res = await apiInstance_V2.get(API_ENDPOINTS.MENU);
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const createOrUpdateCategory = async (category) => {
    try {
      let url = API_ENDPOINTS.CATEGORY;
      if(category.categoryId  != undefined)
      {
        url += `/${category.categoryId}`
      }
      const res = await apiInstance_V2[category.categoryId  === undefined ? 'post' : 'put'](url , category);
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const deleteCategory = async (categoryId) => {
    try {
      let url = API_ENDPOINTS.CATEGORY + `/${categoryId}`;
      const res = await apiInstance_V2['delete'](url);
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const createOrUpdateMenuItem = async (menuItem) => {
    try {
      delete menuItem['categoryDetails']
      let url = API_ENDPOINTS.MENU;
      if(menuItem.id  != undefined)
      {
        url += `/${menuItem.id}`
      }
      const res = await apiInstance_V2[menuItem.id  === '' ? 'post' : 'put'](url , menuItem);
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  }

  const deleteMenuItem = async (id) => {
    try {
      const url = `${API_ENDPOINTS.MENU}/${id}`
      const res = await apiInstance_V2['delete'](url);
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  }

  const reports = async ({
    customStart =  '',
    customEnd = '',
    dateType = 'today',
    pageSize = 20,
    page = 1
  }) => {
    try {
      const res = await apiInstance_V2.get(`${API_ENDPOINTS.REPORTS_V2}?startDate=${customStart}&endDate=${customEnd}&dateType=${dateType}&pageSize=${pageSize}&page=${page}`);
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const liveOrders = async () => {
    try {
      const res = await apiInstance_V2.get(API_ENDPOINTS.ORDER_LIVE_V2);
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const createOrder = async (order) => {
    try {
      const res = await apiInstance_V2.post(API_ENDPOINTS.ORDER, order);
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const updateOrder = async (update) => {
    try {
      const res = await apiInstance_V2.patch(API_ENDPOINTS.ORDER, update);
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const settleOrder = async (order) => {
    try {
      const res = await apiInstance_V2.post(
        API_ENDPOINTS.ORDER_PAYMENT,
        order
      );
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };

  const getOrderDetails = async (payload) => {
    try {
      const res = await apiInstance_V2.get(API_ENDPOINTS.ORDER_BY_ID(payload));
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };


  const outOfStock = async (requestBody) => {
    try {
      const { itemId, categoryId, status } = requestBody;
      const url = `${API_ENDPOINTS.MENU}/${itemId}/status`
      const res = await apiInstance_V2.put(url, {
        categoryId,
        status
      });
      return res.data;
    } catch (err) {
      console.log(err);
      return err.response?.data || { status: "failed", data: null }
    }
  };


  return {
    addCategoryAPI,
    categoryDelete,
    allCategories,
    deleteItem,
    addItemAPI,
    updateItem,
    getAllItems,
    outOfStock,
    tableData,
    getTableData,
    requestedKOTData,
    changeKOTStatus,
    orderDone,
    createOrderByRestarunt,
    extraAmountAdded,
    editExistingOrder,
    paymentMethodAPI,
    orderReject,
    changeQuentityOfItem,
    getPublicItemBYVPA,
    getWaiterList,
    getAllCategoryAndItem,
    syncCloud,
    getOrderHistory,
    getDigitalOrders,
    gstUpdate,
    categoryUpdate,
    itemWiseSale,
    getRestaurantInfo,
    registerNotificationToken,
    testNotification,
    updateWaiter,
    addNewWaiter,
    removeWaiter,
    partnerAPIIngegration,
    changePaymentMethod,
    getCurrentDayOrders,
    cancelOrder,
    getBillByBillNo,
    addPriceRule,
    deletePriceRule,

    // V2
    login,
    updateGST,
    dashboard,
    reports,
    liveOrders,
    createOrder,
    updateOrder,
    settleOrder,
    getMenu,
    createOrUpdateCategory,
    deleteCategory,
    createOrUpdateMenuItem,
    deleteMenuItem,
    getOrderDetails,
  };
};
